import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ceb1daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "toggle-icon toggle-negative rounded-full absolute cursor-pointer flex items-center justify-center",
  style: { height: '27px', width: '27px' }
}
const _hoisted_2 = {
  class: "toggle-icon toggle-positive rounded-full absolute cursor-pointer flex items-center justify-center",
  style: { height: '27px', width: '27px' }
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "toggle-track rounded-note",
  style: { width: '36px', height: '12px', 'border-radius': '6px' }
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center justify-center relative", { fountain: _ctx._fountain }]),
    style: { height: '27px', width: '72px' }
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'i-cursor'],
        class: "icon-sm",
        onClick: _ctx.toggleFountain
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        icon: ['fas', 'pen-fancy'],
        class: "icon-sm",
        onClick: _ctx.toggleFountain
      }, null, 8, ["onClick"])
    ]),
    _hoisted_3
  ], 2))
}